import React from 'react'
import QuestionQuery from '../Components/Page/QuestionQuery'

function HomeQuestion() {
  return (
    <div>
        <QuestionQuery/>
    </div>
  )
}

export default HomeQuestion